import { render } from "./CharacterFavorite.vue?vue&type=template&id=41057491&scoped=true"
import script from "./CharacterFavorite.vue?vue&type=script&lang=js"
export * from "./CharacterFavorite.vue?vue&type=script&lang=js"

import "./CharacterFavorite.vue?vue&type=style&index=0&id=41057491&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41057491"]])

export default __exports__